import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TrustSection() {
    return (
        <section className="trust-section py-5">
            <div className="container text-center">
                <h3>Ils nous font confiance</h3>
                <div className="row my-4">
                    <div className="col-md-2"><img src="axa-logo.png" alt="AXA" className="partner-logo" /></div>
                    <div className="col-md-2"><img src="viiv-logo.png" alt="ViiV" className="partner-logo" /></div>
                    <div className="col-md-2"><img src="enedis-logo.png" alt="Enedis" className="partner-logo" /></div>
                    {/* Ajoutez d'autres logos ici */}
                </div>
                <blockquote className="blockquote text-center">
                    <p className="mb-0">"Formation de qualité exceptionnelle, je recommande vivement !"</p>
                    <footer className="blockquote-footer">Caroline V.</footer>
                </blockquote>
            </div>
        </section>
    );
}

export default TrustSection;